const log = (level, message, data = {}, isException) => {

    if (window.appInsights) {
        if (isException) {
            const exception = message instanceof Error ? message : data.errorMessage;

            const problemId =
                typeof data?.problemId === "string"
                    ? data.problemId
                    : (data?.problemId != null ? JSON.stringify(data.problemId) : "UnhandledException");

            window.appInsights.trackException({
                exception,
                severityLevel: level,
                problemId,
                properties: {
                    ...data,
                }
            });
        } else {
            window.appInsights.trackTrace({
                message: typeof message === "string" ? message : JSON.stringify(message),
                severityLevel: level,
                properties: data
            });
        }
    }
};

export const debug = (message, data) => log(0, message, data, false);
export const info = (message, data) => log(1, message, data, false);
export const warn = (message, data) => log(2, message, data, false);
export const error = (message, data) => log(3, message, data, true);
export const critical = (message, data) => log(4, message, data, false);
